import { getCookie } from '@/utils/common';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import * as Types from '@/store/action-types';
import store from '@/store'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/main.vue'),
        // redirect: ()=>{
        //     if( /jlwx/.test(location.host) ){
        //         return "/documenthome"
        //     }
        //     return "/home"
        // },
        redirect: '/home',
        children: [
            {
                path: "/home",
                name: "home",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/home/index.vue'),
                meta: { keepAlive: true }
            },
            {
                path: "/documenthome",
                name: "documenthome",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/document/index.vue'),
                meta: { keepAlive: true },
                children: [
                    {
                        path: "/doc/flow",
                        name: "flow",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/document/flow.vue'),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/doc/sso",
                        name: "sso",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/document/sso.vue'),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/doc/interfacelist/:groupid/:groupname",
                        name: "interfacelist",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/document/interfaceList.vue'),
                        props: (route) => ({ groupid: route.params.groupid, groupname: route.params.groupname }),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/doc/interfacedetail/:groupid/:groupname/:apiId",
                        name: "interfacedetail",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/document/interfaceDetail.vue'),
                        props: (route) => ({ groupid: route.params.groupid, groupname: route.params.groupname, apiId: route.params.apiId }),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/doc/returncode",
                        name: "returncode",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/document/returnCode.vue'),
                        meta: { keepAlive: true }
                    },
                ]
            },

            {
                path: "/log",
                name: "log",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/loghome/index.vue'),
                meta: { keepAlive: false },
                redirect: '/log/index',
                children: [
                    {
                        path: "index",
                        name: "index",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/loghome/home.vue'),
                        meta: { keepAlive: false },

                    },
                    {
                        path: "app",
                        name: "app",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/loghome/app.vue'),
                        meta: { keepAlive: false },
                        props: (route) => Object.assign(route.params, route.query),
                    },
                ]
            },


            {
                path: "/personalhome",
                name: "personalhome",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/index.vue'),
                meta: { keepAlive: true },
                children: [
                    {
                        path: "/myapp",
                        name: "myapp",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/myApp.vue'),
                        meta: { keepAlive: true }
                    }
                ]
            },
            {
                path: "/addapp",
                name: "addapp",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/addApp.vue'),
                meta: { keepAlive: true }
            },
            {
                path: "/manageappindex",
                name: "manageappindex",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/manageAppIndex.vue'),
                meta: { keepAlive: true },
                children: [
                    {
                        path: "/appinfo",
                        name: "appinfo",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/appInfo.vue'),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/authschool",
                        name: "authschool",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/authSchool.vue'),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/interfacemanage",
                        name: "interfacemanage",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/interfaceManage.vue'),
                        meta: { keepAlive: true }
                    },
                    {
                        path: "/changedatamanage",
                        name: "changedatamanage",
                        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/personal/changeDataManage.vue'),
                        meta: { keepAlive: true }
                    }
                ]
            },
            {
                path: "/editfactoryinfo",
                name: "editfactoryinfo",
                component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/home/editFactoryInfo.vue'),
                meta: { keepAlive: true }
            },
        ]
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "about" */ '../views/frontSite/register/index.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/openapimgeAuthSchoolList',
        name: 'openapimgeAuthSchoolList',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/appMge/authSchoolList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/openapimgeApplyAPIList',
        name: 'openapimgeApplyAPIList',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/appMge/applyAPIList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/openapimgeParamsMge',
        name: 'openapimgeParamsMge',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/apiMge/paramsMge.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/openapimgeReturnparamsmge',
        name: 'openapimgeReturnparamsmge',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/apiMge/returnParamsMge.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/userList',
        name: 'userList',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/userMge/userList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/appList',
        name: 'appList',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/appMge/appList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/magauthschool',
        name: 'magauthschool',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/appMge/authSchoolList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/interfaceList',
        name: 'interfaceList',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/apiMge/interfaceList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/groupList',
        name: 'groupList',
        component: () => import(/* webpackChunkName: "about" */ '../views/manage/apiMge/groupList.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/zpfaq',
        name: 'zpfaq',
        component: () => import(/* webpackChunkName: "about" */ '../views/zpFAQ/list.vue'),
        // component: () => import(/* webpackChunkName: "about" */ '../views/zpFAQ/modules/myTiny.vue'),

        meta: {
            keepAlive: false
        }
    },
]

// const router = createRouter({
//     history: createWebHistory(process.env.BASE_URL),
//     routes
// })

// router.beforeEach((to, from, next) => {
//     let userId = getCookie('userid');
//     let enterpriseFullName = store.state.user.enterpriseFullName;
//     if (userId) {
//         if (!enterpriseFullName) {
//             store.dispatch(`user/${Types.SET_USER_INFO}`,
//                 { userId: userId }).then(res => {
//                     next();
//                 }).catch(res => {
//                     console.log(res);
//                     document.cookie = "token=" + ";path=/";
//                     document.cookie = "userid=" + ";path=/";
//                     next("/");
//                 });
//         } else {
//             next();
//         }
//     } else {
//         next();
//     }
// });

export default routes
